import PickUpFormulario from "./PickUpFormulario";

export default PickUpFormulario;
